import * as appConstants from "@store/app/constants";


export const appStart = (payload) => ({type: appConstants.APP_START, payload});
